// sessionUtils.ts - セッションIDと時間関連のユーティリティ関数

/**
 * UUIDを生成する関数
 * @returns UUID v4 (ランダムUUID)
 */
export const generateUUID = (): string => {
	// Web Crypto APIによる安全なUUID生成
	if (crypto && "randomUUID" in crypto) {
		return crypto.randomUUID();
	}

	// 古いブラウザ向けフォールバック (ただし非推奨)
	// 参考: RFC4122 https://www.ietf.org/rfc/rfc4122.txt
	console.warn("crypto.randomUUID()が利用できないため、フォールバック実装を使用します");
	return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
		const r = (Math.random() * 16) | 0;
		const v = c === "x" ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
};

/**
 * ブラウザセッションのUUID
 * - ページを開いた時に生成され、タブを閉じるまで同じ値を持つ
 */
export const getSessionId = (): string => {
	let sessionId = window.sessionStorage.getItem("session_id");
	// セッションIDがなければ生成して保存
	if (!sessionId) {
		sessionId = generateUUID();
		window.sessionStorage.setItem("session_id", sessionId);
	}

	return sessionId;
};

/**
 * 指定された日時が現在から1時間以内かどうかを判定
 * @param timestamp 確認したいタイムスタンプ（ミリ秒）
 * @returns 1時間以内ならtrue、それ以外はfalse
 */
export const isWithinLastHour = (timestamp: number): boolean => {
	const ONE_HOUR_MS = 60 * 60 * 1000;
	const now = Date.now();
	return now - timestamp <= ONE_HOUR_MS;
};

/**
 * ファイル名に使用するローカル時間のタイムスタンプを生成
 * フォーマット: YYYY-MM-DDTHH-MM-SS (例: 2025-05-30T14-30-45)
 * @param date 省略時は現在時刻を使用
 * @returns フォーマット済みのタイムスタンプ文字列
 */
export const generateLocalTimestamp = (date = new Date()): string => {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const day = String(date.getDate()).padStart(2, "0");
	const hours = String(date.getHours()).padStart(2, "0");
	const minutes = String(date.getMinutes()).padStart(2, "0");
	const seconds = String(date.getSeconds()).padStart(2, "0");
	return `${year}-${month}-${day}T${hours}-${minutes}-${seconds}`;
};
